import { useState, useEffect, useRef, createRef } from 'react';
import { useTranslation } from 'react-i18next';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import CardView from '../CardView/CardView';
import DummyView from '../CardView/DummyCard';
import {
  CloseSideBarSVG,
  ExpandSideBarSVG,
} from '../../../../img/bottom-sidebar/BottomSideBarSVG';
import { useDispatch } from 'react-redux';
import {
  resetRecentSearchList,
  setSelectedCheckedItems,
  setSelectedCheckedRowData,
} from '../../../../../redux/member/priceCompareSlice';
import './BottomSideBar.scss';
import { useNavigate } from 'react-router-dom';

const BottomSideBar = ({
  selectedCheckedItems,
  selectedCheckedRowData,
  tableRef,
}) => {
  const cardRefs = useRef([]);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isItemsSelected = selectedCheckedItems.length > 0;
  const isCompareDisabled = selectedCheckedItems.length <= 0;
  const staticArray = Array(3).fill(1);
  //For Accessibility
  cardRefs.current = staticArray.map((ele, i) => createRef());
  const [open, setOpen] = useState(false);

  const toggleSideBarHandler = () => {
    setOpen(!open);
  };

  const removeAll = () => {
    dispatch(setSelectedCheckedItems([]));
    dispatch(setSelectedCheckedRowData([]));

    //For Accessibility start
    if (tableRef && tableRef?.current) {
      tableRef?.current.focus();
      setTimeout(() => {
        tableRef?.current.blur();
      }, 1000);
    }
    //For Accessibility end
  };

  useEffect(() => {
    if (!isItemsSelected) {
      setOpen(false);
    }
  }, [isItemsSelected]);

  useEffect(() => {
    //Need to clear the selected items while unmounting
    return () => {
      //removeAll();
    };
  }, []);

  const handleCompareResult = () => {
    dispatch(resetRecentSearchList());
    navigate('/member/price-compare/show-result', {
      state: {
        from: 'search',
      },
    });
  };

  return (
    <div
      aria-label="compare price tool panel"
      className={`bottom-sidebar-wrapper ${open && 'collapsed-bar'} ${
        isItemsSelected ? 'sidebar-open' : 'sidebar-close'
      }`}
    >
      <div className="container">
        <div className="sr-only">compare price tool panel</div>
        <div className="top-section">
          <div className="top-section-wrapper">
            <div className="blueTitle">
              {t('member.price_comparison.bottom_compare_panel_heading_text')}{' '}
              {open && (
                <span className="mobile-selected-count">
                  ({selectedCheckedItems.length})
                </span>
              )}
            </div>
            <div
              className={`tab-bg ${open && 'down-tab'}`}
              role="button"
              //aria-label="Click to expand and collapse the panel"
              onClick={() => toggleSideBarHandler()}
              tabIndex={0}
              aria-expanded={!open}
              aria-label={
                open
                  ? 'collapsed compare price tool panel. Click to expand the panel'
                  : 'expanded compare price tool panel.  Click to collapse the panel'
              }
            >
              <ExpandSideBarSVG />
            </div>
          </div>
          {open && (
            <div role="status" className="top-sub-section-collapsed">
              You have selected {selectedCheckedItems.length} out of 3 options.
            </div>
          )}
          <div className="right-section">
            <div
              className="remove-all"
              role="button"
              onClick={() => removeAll()}
            >
              Remove All{' '}
              <span className="sr-only"> the selected providers</span>
            </div>
            <div
              aria-label="Remove all the selected providers and close the panel"
              role="button"
              className="closeIconPosition"
              onClick={() => removeAll()}
            >
              <CloseSideBarSVG className="closeIcon" />
            </div>
          </div>
        </div>
        <div className="middle-section">
          {selectedCheckedRowData && (
            <div className="card-wrapper">
              {staticArray.map((item, index) => (
                <div
                  className={`${
                    selectedCheckedRowData && selectedCheckedRowData[index]
                      ? 'card-item card-info-item'
                      : 'card-item card-dummy-item'
                  }`}
                  key={`item-${index}`}
                >
                  {selectedCheckedRowData && selectedCheckedRowData[index] ? (
                    <CardView
                      data={selectedCheckedRowData[index]}
                      index={index}
                      tableRef={tableRef}
                      cardRefs={cardRefs}
                    />
                  ) : (
                    <DummyView />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="bottom-section">
          <GenericButton
            disable={isCompareDisabled}
            buttonDisabled={true}
            ariaLabel={
              isCompareDisabled
                ? 'Select a minimum of 2 and maximum of 3 providers'
                : 'Click to compare the selected providers and estimate cost'
            }
            onClick={() => {
              handleCompareResult();
            }}
          >
            {selectedCheckedItems.length === 1
              ? 'Estimate Cost'
              : 'Estimate Cost'}
          </GenericButton>
          <div className="remove-all" onClick={() => removeAll()}>
            Remove All
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomSideBar;
